// TSS vite/03 §"Query keys convention".

export const farmKeys = {
    all:      ['farms'],
    list:     (filters) => ['farms', 'list', filters],
    infinite: (filters, limit) => ['farms', 'list', 'infinite', filters, limit],
    detail:   (id)      => ['farms', 'detail', id],
};
